import { watch } from "@aurelia/runtime-html";
import {
  BindingMode,
  bindable,
  capture,
  inject,
  resolve,
} from "aurelia";
import { IFormInputOption } from "../interfaces/form-interface";
import { IValidationController, ValidationController } from "@aurelia/validation-html";

@capture((attrs) => attrs !== "id" && attrs !== "label" && attrs !== "validate" && attrs !== "selectedValue" && attrs !== "selectedItem" && attrs !== "searchCallback")
@inject(Element)
export class TypeaheadComponent {
  private id: string = crypto.randomUUID();
  @bindable({ mode: BindingMode.twoWay }) selectedItem: IFormInputOption;
  @bindable({ mode: BindingMode.twoWay }) selectedValue: string;

  @bindable public validate: boolean = false;
  @bindable public required: boolean = false;
  @bindable public label: string = "";
  @bindable public helper: string
  @bindable searchCallback: (query: string) => Promise<IFormInputOption[]>;
  private loading: boolean = false;

  @bindable public items: IFormInputOption[] = []
  private filteredItems: IFormInputOption[] = [];

  private element: Element;
  private inputElement: HTMLInputElement;
  private isDropdownOpen: boolean = false;

  constructor(element: Element,
    private validationController: IValidationController = resolve(ValidationController)
  ) {
    this.element = element;
  }

  attached(): void {
    if (this.selectedItem) {
      this.selectedValue = this.selectedItem.label;
    }

    this.inputElement = document.getElementById(this.id) as HTMLInputElement;

    this.filteredItems = [...this.items]
    document.addEventListener("click", this.outsideClickListener);
  }

  @watch('selectedValue')
  private async changeSelectedValue(newValue: string, oldValue: string): Promise<void> {
    const normalizedSelectedValue = newValue?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

    if (!newValue) {
      this.selectedItem = null;

      this.filteredItems = [...this.items]

      return
    }

    this.loading = true;
    const items = await this.searchCallback(normalizedSelectedValue);
    this.filteredItems = items.length ? items : await this.searchCallback(newValue);

    this.loading = false;
  }

  detached(): void {
    document.removeEventListener("click", this.outsideClickListener);
  }

  private async selectItem(item: IFormInputOption, event: Event) {
    event.stopPropagation();

    this.selectedItem = item;
    this.selectedValue = item.label;

    if (this.validate) await this.validateValue();

    this.isDropdownOpen = false;
  }

  async validateValue() {
    await this.validationController.validate();
  }

  private showDropdown(): void {
    this.isDropdownOpen = true;
    if (!this.selectedValue) {
      this.filteredItems = [...this.items]
    }
  }

  private async hideDropdown() {
    this.isDropdownOpen = false;

    if (!this.selectedItem || this.selectedValue != this.selectedItem.label) {
      this.selectedValue = null;
      this.selectedItem = null;
    }

    if (this.validate) await this.validateValue();

  }

  private outsideClickListener = (event: Event): void => {
    const targetElement = event.target as HTMLElement;

    // Verifica se o clique ocorreu fora do componente
    if (!this.element.contains(targetElement)) {
      this.hideDropdown();
    }
  };
}
